import React, { Component } from 'react';
import styles from './availableSizesOverlayModal.scss';
import AvailableSizes from './availableSizes';
import { IL10N } from '../../../../Common/l10n-keys';
import { IColorToAvailableSizes, ISdvColor } from '../article-tile.d';
import classNames from 'classnames';
import Cross from '../../../../Assets/svg/cross';
import * as helper from '../../../../Common/html-helper';

export default class AvailableSizesOverlayModal extends Component<{l10n: IL10N,
    colorsToAvailableSizes: IColorToAvailableSizes[],
    toggleAvailableSizes(): void,
    showAvailableSizesOverlay: boolean,
    dcvColorCode: number,
    masterArticleNo: number,
    salesArticleVariantColors: ISdvColor[]
}, {imgLoadDone: boolean}> {

    constructor(props) {
        super(props);

        this.state = {
            imgLoadDone: false
        }
    }

    componentDidUpdate(prevProps): void {
        // if new articles was selected, reset state, because new sizes and colors will be rendered:
        if(prevProps.masterArticleNo !== this.props.masterArticleNo)
        {
            if(prevProps.colorsToAvailableSizes.length === this.props.colorsToAvailableSizes.length) {
                // different article, same single color, no need to re-render it
                // just show sizes
                return;
            }

            this.setState({imgLoadDone: false});
        }
    }

    private subscribeToAVS() {
        this.setState({imgLoadDone: true});
    }

    private handleCloseBtnClick() {
        this.props.toggleAvailableSizes();
    }

    public render() {
        if(!this.props.showAvailableSizesOverlay)
            return <></>;

        return (
            <div data-testid='availableSizesOverlayModal' data-semantic-id='availableSizesOverlayModal'
                className={classNames(styles.availableSizesOverlayModal,
                    { [styles.show_overlay]: 
                        this.state.imgLoadDone && this.props.showAvailableSizesOverlay})}
            >
                <div className={styles.content}>
                    <div className={styles.header}>
                        <span className={styles.title}>
                            {helper.decodeHTML(this.props.l10n.availableSizes)}
                        </span>
                        <span onClick={this.handleCloseBtnClick.bind(this)} className={styles.close_btn_icon}>
                            <Cross />
                        </span>
                    </div>
                    <AvailableSizes
                        colorsToAvailableSizes={this.props.colorsToAvailableSizes}
                        showAvailableSizesMenu={true}
                        dcvColorCode={this.props.dcvColorCode}
                        toggleAvailableSizes={null}
                        notifySubscriber={this.subscribeToAVS.bind(this)}
                        masterArticleNo={this.props.masterArticleNo}
                        salesArticleVariantColors={this.props.salesArticleVariantColors}
                    />
                    <div className={styles.footer} data-testid='footer' data-semantic-id='footer'>
                        <span data-testid='close_button' data-semantic-id='close_button' className={styles.close_button} 
                        onClick={this.handleCloseBtnClick.bind(this)}>{helper.decodeHTML(this.props.l10n.close)}</span>
                    </div>
                </div>
            </div>
        );
    }
}

